import { parseTemplate } from 'url-template';

import { BE_API } from '~/env';
/**
 * /api/v1//vehicle/{vehicle}/{region}
 * @param vehicle
 * @param region
 */
export const ProductConfigurationApiUrl = parseTemplate(`${BE_API}/api/v1/search/requests/{requestId}/manifest`);
//export const ProductConfigurationApiUrl = parseTemplate(`${BE_API}/api/v1/proxy/vehicle/{vehicle}/{market}`);

/**
 * /img?job=p=VehiclePrefab&vehicle={vehicle}&region={region}&c={camera}&cw={cameraWaypoint}&f={features}
 * https://docs.unity3d.com/Packages/com.unity.industrial.renderstudio@1.2/manual/image-on-demand.html
 * @param vehicle - vehicle model
 * @param region - region name
 * @param camera - camera name
 * @param features - vehicle features
 * @param cameraWaypoint - camera waypoint
 */
// eslint-disable-next-line max-len
export const VehicleImageUrl = parseTemplate(`${BE_API}/api/v1/proxy/image?p=VehiclePrefab&vehicle={vehicle}&region={region}&c={camera}&cw={cameraWaypoint}&f={features}`);

/**
 * @param region - currently selected region
 * @param pov - combination of camera and waypoint (Ex: E16 = Exterior 360, 16th waypoint)
 * @param width - image width
 * @param vehicle - vehicle code from EIM
 * @param paint - paint code from EIM
 * @param fabric - fabric code from EIM
 * @param sa - string representing comma separated list of all EIM values.
 */
// eslint-disable-next-line max-len
export const IrisVehicleImageUrl = parseTemplate(`${BE_API}/api/v1/proxy/image?region={region}&pov={pov}&bkgnd=5&width={width}&vehicle={vehicle}&paint={paint}&fabric={fabric}&sa={sa}`);

/**
 * @param year - currently selected year (obtained from Jira)
 * @param vehicle - vehicle name (obtained from Jira)
 * @param trim - Trim level (obtained from the UI)
 * @param cameraName - Camera name, part of the folder structure / camera selected from the manifest
 * @param frame - frame to match - part of the filename, from the manifest
 * @param extcolor - Exterior Color from the manifest/UI
 * @param intcolor - Interior Color from the manifest/UI
 * @param type - blank, preview, thumb - if it's blank, or the folder doesn't exist, it will 
 */
// eslint-disable-next-line max-len
export const S3ImageUrl = parseTemplate(`${BE_API}/api/v1/proxy/image/fimage?year={year}&vehicle={vehicle}&trim={trim}&camera={cameraName}&frame={frame}&extcolor={extcolor}&intcolor={intcolor}&type={type}`);

/**
 * @param year - currently selected year (obtained from Jira)
 * @param vehicle - vehicle name (obtained from Jira)
 */
export const ValidateUrl = parseTemplate(`${BE_API}/api/v1/proxy/image/validate?year={year}&vehicle={vehicle}`);

/**
 * ${BE_API}/api/v1/authentication?redirectUri={redirect_uri}
 * @param redirect_uri - env. {BE_DOMAIN}/callback
 * @see {@link https://developer.atlassian.com/cloud/jira/platform/oauth-2-3lo-apps/#faq3}
 * @see {@link https://developer.atlassian.com/console/myapps} - login as JIRA admin
 */
//export const JiraAuthUrl = parseTemplate(`${JIRA_AUTH}/authorize?audience=api.atlassian.com&response_type=code&prompt=consent{&client_id,scope,redirect_uri,state}`);
export const JiraAuthUrl = parseTemplate(`${BE_API}/api/v1/authentication?redirectUri={redirect_uri}`);

/**
 * ${BE_API}/api/v1/user/me
 */
export const JiraMeApiUrl = `${BE_API}/api/v1/user/me`;

export const LogoutUrl = `${BE_API}/api/v1/authentication/logout`;

export const CsrfTokenUrl = `${BE_API}/api/v1/authentication/csrf`;

export const JiraRequestsApiUrl = parseTemplate(`${BE_API}/api/v1/search/requests{?startAt,maxResults,jql,market,search}`);

export const JiraRequestByIdUrl = parseTemplate(`${BE_API}/api/v1/search/requests/{requestId}{?jql,fieldsByKeys,fields,market,search}`);

export const JiraRequestOpenIssuesCountUrl = parseTemplate(`${BE_API}/api/v1/search/requests/{requestId}/openissues/count`);

export const JiraRequestIssuesUrl = parseTemplate(`${BE_API}/api/v1/search/requests/{requestId}/issues{?startAt,maxResults}`);

export const JiraIssueByIdUrl = parseTemplate(`${BE_API}/api/v1/search/requests/{requestId}/issues/{issueId}`);

/**
 * ${BE_API}/api/v1/issue/{issueId}{?expand}
 * @param issueId - issue Id
 * @see {@link https://developer.atlassian.com/cloud/jira/platform/rest/v2/api-group-issues/#api-rest-api-2-issue-post}
 * @see {@link https://developer.atlassian.com/cloud/jira/platform/rest/v2/api-group-issues/#api-rest-api-2-issue-issueidorkey-put}
 */
export const JiraIssueApiUrl = parseTemplate(`${BE_API}/api/v1/issue/{issueId}{?expand}`);

/**
 * ${BE_API}/api/v1/issue/createmeta?expand=projects.issuetypes.fields
 * WARNING: The project key is not being passed to the URL. It may be an error, or not, only by investigating further past changes it would
 * be possible to understand that
 * @param projectKey = Key of project
 * @see {@link https://developer.atlassian.com/cloud/jira/platform/rest/v3/api-group-issues/#api-rest-api-3-issue-createmeta-get/}
 */
export const JiraCreateMetaApiUrl = parseTemplate(`${BE_API}/api/v1/issue/createmeta?expand=projects.issuetypes.fields{&projectKeys}`);

/**
 * ${BE_API}/api/v1//issue/{issueKey}/attachments
 * @param issueKey - issue key
 * @see {@link https://developer.atlassian.com/cloud/jira/platform/rest/v3/api-group-issue-attachments/#api-rest-api-3-issue-issueidorkey-attachments-post}
 */
export const JiraIssueAttachmentApiUrl = parseTemplate(`${BE_API}/api/v1/issue/{issueKey}/attachments`);

/**
 * ${BE_API}/api/v1/attachment/content/{attachmentId}
 * @param attachmentId - id for the requested attachment
 * @see {@link https://developer.atlassian.com/cloud/jira/platform/rest/v3/api-group-issue-attachments/#api-rest-api-3-attachment-content-id-get}
 */
export const JiraGetAttachmentApiUrl = parseTemplate(`${BE_API}/api/v1/attachment/content/{attachmentId}?redirect=false`);

/**
 * ${BE_API}/api/v1/issue/{issueId}/comment
 * @param issueId - issue key
 * @param startAt - optional - when GET list of comments (default 0)
 * @param maxResults - optional - when GET list of comments (default 5000)
 * @param orderBy - optional - when GET list of comments
 * @param expand - optional - set to renderedBody when GET list of comments
 * @see {@link https://developer.atlassian.com/cloud/jira/platform/rest/v2/api-group-issue-comments/#api-rest-api-2-issue-issueidorkey-comment-post}
 * @see {@link https://developer.atlassian.com/cloud/jira/platform/rest/v2/api-group-issue-comments/#api-rest-api-2-issue-issueidorkey-comment-post}
 */
export const JiraIssueCommentApiUrl = parseTemplate(`${BE_API}/api/v1/issue/{issueId}/comment{?startAt,maxResults,orderBy,expand}`);

/**
 * ${BE_API}/api/v1/project/statuses
 * @param projectKey - projectKey
 * @see {@link https://developer.atlassian.com/cloud/jira/platform/rest/v3/api-group-projects/#api-rest-api-3-project-projectidorkey-statuses-get}
 */
export const JiraIssueTypeStatusesApiUrl = `${BE_API}/api/v1/project/statuses`;

export const JiraIssueTypeStatusByNameApiUrl = parseTemplate(`${BE_API}/api/v1/project/statuses/{typeName}`);

/**
 * ${BE_API}/api/v1/issue/{issueId}/transitions
 * @param issueId - issue key
 * @param expand - optional - set to renderedBody when GET list of comments
 * @param sortByOpsBarAndStatus - optional
 * @see {@link https://developer.atlassian.com/cloud/jira/platform/rest/v3/api-group-issues/#api-rest-api-3-issue-issueidorkey-transitions-get}
 */
export const JiraIssueTransitionsApiUrl = parseTemplate(`${BE_API}/api/v1/issue/{issueId}/transitions{?expand,sortByOpsBarAndStatus}`);

export const ConfigApiUrl = `${BE_API}/api/v1/config`;
